import { useEffect, useState } from "react";
import { List, Typography, Space, Pagination, Tag } from "antd";
import dayjs from "dayjs";
import { useGlobalState } from "../../components/global";
import { vipType } from "../const";
import UUIDComponent from "../../components/UUIDComponent";

const { Text } = Typography;

const isContinuousType = (value: string) => value?.startsWith("CONTINUOUS_");

export default function UserMemberDetail({ item }: any) {
    const { jsonRequest } = useGlobalState();
    const [records, setRecords] = useState<any[]>([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    const getDetail = async (page = 1) => {
        jsonRequest.get(`/back/vip-activation-record/page`, {
            pageSize: pagination.pageSize,
            currentPage: page,
            userId: item.id,
        })
            .then((resp: any) => resp.json())
            .then(async ({ data }: any) => {
                setRecords(data.data);
                setPagination({
                    ...pagination,
                    current: page,
                    total: data.count
                });
            });
    };

    useEffect(() => {
        if (item?.id) {
            getDetail();
        }
    }, []);

    const handlePageChange = (page: number) => {
        getDetail(page);
    };

    const renderEmptyState = () => {
        if (!item) return null;

        return (
            <List.Item>
                <Space direction="vertical">
                    <Text>
                        <Text strong>后台套餐</Text>
                        <Text type="secondary">
                            {item.vipPermanentFlag
                                ? ' (永久)'
                                : ` (${dayjs(item.vipExpireDate).format('YYYY-MM-DD')}到期)`}
                        </Text>
                    </Text>
                </Space>
            </List.Item>
        );
    };

    return (
        <div>
            <List
                dataSource={records.length > 0 ? records : [{}]}
                renderItem={(data: any, index: number) => (
                    records.length > 0 ? (
                        <List.Item>
                            <Space direction="vertical">
                                <Text>
                                    <Text strong>
                                        {data?.vipValue > 0 && !isContinuousType(data?.vipType)
                                            ? `${data?.vipValue}${vipType[data?.vipType as keyof typeof vipType]?.text || ''}`
                                            : vipType[data?.vipType as keyof typeof vipType]?.text || ''}
                                    </Text>
                                    <Text type="secondary">
                                        {data?.vipType === 'PERMANENT'
                                            ? ` (${dayjs(data.effectiveDateBegin).format('YYYY-MM-DD')}开始)`
                                            : ` (${dayjs(data.effectiveDateBegin).format('YYYY-MM-DD')} 至 ${dayjs(data.effectiveDateEnd).format('YYYY-MM-DD')})`
                                        }
                                    </Text>
                                    <Text type={data?.status === 'NORMAL' ? "success" : "danger"} style={{ marginLeft: 8 }}>
                                        {data?.status === 'NORMAL' ? '正常' : '已取消'}
                                    </Text>
                                    {isContinuousType(data?.vipType) && (
                                        <Tag
                                            color={data?.subscriptionInfo?.autoRenew === true
                                                ? "success"
                                                : data?.subscriptionInfo?.autoRenew === false ? "warning" : "default"}
                                            style={{ marginLeft: 8 }}
                                        >
                                            {data?.subscriptionInfo?.autoRenew === true
                                                ? "续订中"
                                                : data?.subscriptionInfo?.autoRenew === false ? "已关闭续订" : "待同步"}
                                        </Tag>
                                    )}
                                </Text>
                                {data?.externalAgreementNo && (
                                    <Text type="secondary">
                                        订阅协议号：<UUIDComponent value={data.externalAgreementNo} flag={true} />
                                    </Text>
                                )}
                            </Space>
                        </List.Item>
                    ) : renderEmptyState()
                )}
            />
            <div style={{ textAlign: 'right', marginTop: 16 }}>
                <Pagination
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                />
            </div>
        </div>
    );
}
